export default "__VITE_ASSET__DxYkKWKY__"